import TabPanel from '@components/Tabs/TabPanel';
import { Theme as ThemeType } from '@descope/page-editor-components';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { IProps } from 'types/common';
import React from 'react';
import Theme from './Theme';
import { UpdateTheme } from './types';

interface Props extends IProps {
	lightTheme: ThemeType;
	darkTheme: ThemeType;
	updateLightTheme: UpdateTheme;
	updateDarkTheme: UpdateTheme;
}

const Themes = ({
	lightTheme,
	updateLightTheme,
	darkTheme,
	updateDarkTheme,
	children
}: Props) => {
	const [value, setValue] = React.useState(0);

	const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	return (
		<Box
			display="flex"
			flexDirection="column"
			sx={{ width: '100%', overflow: 'hidden' }}
		>
			<Box
				justifyContent="space-between"
				alignItems="center"
				display="flex"
				sx={{ borderBottom: 1, borderColor: 'divider', pl: 3 }}
			>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label="basic tabs example"
				>
					<Tab label={intl.tr('styleEditor.theme.light')} sx={{ width: 250 }} />
					<Tab label={intl.tr('styleEditor.theme.dark')} sx={{ width: 250 }} />
				</Tabs>
				{children}
			</Box>
			<TabPanel
				sx={{ overflow: 'hidden' }}
				value={value}
				id={0}
				labelId="light"
				controllerId="light"
			>
				<Theme
					theme={lightTheme}
					updateTheme={updateLightTheme}
					themeName="light"
				/>
			</TabPanel>
			<TabPanel
				sx={{ overflow: 'hidden' }}
				value={value}
				id={1}
				labelId="dark"
				controllerId="dark"
			>
				<Theme
					theme={darkTheme}
					updateTheme={updateDarkTheme}
					themeName="dark"
				/>
			</TabPanel>
		</Box>
	);
};

export default Themes;
